import {
	Glyphs,
	WidgetLabel,
	WidgetOptInCheckbox,
	WidgetSelectGroup,
	type WidgetSelectGroupItem,
} from '../../../../rapid-ui'
import type { TextAlignMode, TextAlignValue } from '../../data/v1'

const textAlignItems: WidgetSelectGroupItem<TextAlignValue>[] = [
	{ id: 'left', label: 'Left', render: () => <Glyphs.core.TextAlignLeftIcon /> },
	{ id: 'center', label: 'Center', render: () => <Glyphs.core.TextAlignCenterIcon /> },
	{ id: 'right', label: 'Right', render: () => <Glyphs.core.TextAlignRightIcon /> },
]

export type TextAlignInspectorProps = {
	mode: TextAlignMode
	value: TextAlignValue
	onModeChange: (mode: TextAlignMode) => void
	onChange: (value: TextAlignValue) => void
}

export function TextAlignInspector({ mode, value, onModeChange, onChange }: TextAlignInspectorProps) {
	return (
		<WidgetLabel label="Align">
			<WidgetOptInCheckbox
				optedIn={mode !== 'auto'}
				onOptIn={() => onModeChange('value')}
				onOptOut={() => onModeChange('auto')}
			>
				<WidgetSelectGroup
					value={value}
					onChange={onChange}
					items={textAlignItems}
				/>
			</WidgetOptInCheckbox>
		</WidgetLabel>
	)
}
